import { render, staticRenderFns } from "./LoadingButton.vue?vue&type=template&id=89b29174"
import script from "./LoadingButton.vue?vue&type=script&setup=true&lang=js"
export * from "./LoadingButton.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports